import AppDispatcher from '../../core/AppDispatcher'
import CheckInEvent from '../../event/CheckInEvent'

const addGuest = index => {
  AppDispatcher.dispatchWithType(CheckInEvent.addGuest, { index: index })
  return true
}

export default addGuest
